// extracted by mini-css-extract-plugin
export default {"float":"float__xN3zw","post":"post__U8l-z","background":"background__cYyFD","meta":"meta__VmMUx"};